import { CardStatus, LearningProgressStatus } from '../constants';

export const mapLearningProgressToCardStatus = (status?: LearningProgressStatus): CardStatus => {
  switch (status) {
    case LearningProgressStatus.COMPLETED:
      return CardStatus.COMPLETED;
    case LearningProgressStatus.IN_PROGRESS:
    case LearningProgressStatus.NOT_STARTED:
    default:
      return CardStatus.DEFAULT;
  }
};

export const isEntitySelected = (courseSlug: string, lessonSlug?: string, sectionSlug?: string): boolean => {
  const currentPath = globalThis.location.pathname;
  const currentHash = globalThis.location.hash;

  if (courseSlug) {
    return currentPath.includes(`/course/${courseSlug}`);
  }

  if (sectionSlug === 'quiz') {
    return currentPath.includes(`lesson/${lessonSlug}`) && currentHash === '#quiz';
  }

  if (sectionSlug) {
    return currentPath.includes(`/lesson/${lessonSlug}`) && currentHash === `#${sectionSlug}`;
  }

  if (lessonSlug) {
    const lessonPath = `/lesson/${lessonSlug}`;
    return currentPath.endsWith(lessonPath) || currentPath.includes(lessonPath + '/');
  }

  return currentHash === `#${sectionSlug}`;
};
